import OperatingViewOperator from '@/module/monitoringCenter/page/operatingView_operator.vue'
import OperatingViewScreen from '@/module/monitoringCenter/page/operatingView_screen.vue'
import OperatingViewScreen4 from '@/module/monitoringCenter/page/operatingView_screen4.vue'
import DataVisual from '@/module/monitoringCenter/page/dataVisual.vue'
import layout from '@/layout/index'
// 导出配置的路由器
export default [{
  path: '/monitoringCenter',
  component: layout,
  redirect: 'monitoringCenter/operatingView_operator',
  meta: {title: '监控中心', icon: 'icon-yunwei',perms:['bee:monitor']},
  children: [
    {
      path: 'operatingView_screen',
      redirect: '/monitoringCenter/screen',
      meta: {
        title: '运营总览(总监控屏)', icon: 'icon-yunwei', perms: ['bee:order:screen']
      },
      extra: {isLink: true, linkType: 'in'}
    },
    {
      path: 'operatingView_screen4',
      redirect: '/monitoringCenter/screen4',
      meta: {
        title: '运营总览(总监控屏)', icon: 'icon-yunwei', perms: ['bee:order:screen']
      },
      extra: {isLink: true, linkType: 'in'}
    },
    {
      path: 'operatingView_operator',
      component: OperatingViewOperator,
      meta: {title: '运营总览(运营商版)', icon: 'icon-yingxiao1',perms: ['bee:order:operatorScreen']}
    },
    {
      path: 'dataVisual',
      component: DataVisual,
      meta: {title: '数据可视化', icon: 'icon-shuju',perms: ['bee:res:dataView']}
    }
  ]
},
  {
    path: '/monitoringCenter/screen',
    component: OperatingViewScreen,
    hidden: true
  },
  {
    path: '/monitoringCenter/screen4',
    component: OperatingViewScreen4,
    hidden: true
  }
]



// WEBPACK FOOTER //
// ./src/module/monitoringCenter/router/index.js